import { AlertsWidget } from "./AlertsWidget"
import { MetricCard } from "./components"
import { formatNumber } from "./dashboardData"
import { OrdersWidget } from "./OrdersWidget"
import { PerformanceTestsWidget } from "./PerformanceTestsWidget"
import { ThermostatsWidget } from "./ThermostatsWidget"
import { TrendsWidget } from "./TrendsWidget"
import { useEnterpriseDashboardData } from "./useEnterpriseDashboardData"

import styles from "./index.module.scss"

export const EnterpriseDashboard = () => {
  const dashboard = useEnterpriseDashboardData()

  return (
    <main className={styles.page}>
      <div className={styles.metricsGrid}>
        <MetricCard
          title="Total Contractors"
          value={formatNumber(dashboard.totalStats.total_contractors)}
          helper="Number of contractors"
          isLoading={dashboard.isTotalStatsFetching}
        />
        <MetricCard
          title="Total Customers"
          value={formatNumber(dashboard.totalStats.total_customers)}
          helper="Number of customers, excluding archived ones."
          isLoading={dashboard.isTotalStatsFetching}
        />
        <MetricCard
          title="Total Thermostats"
          value={formatNumber(dashboard.totalStats.thermostats)}
          helper="Numbers of Thermostats"
          isLoading={dashboard.isTotalStatsFetching}
        />
        <MetricCard
          title="Mobile app"
          value={formatNumber(dashboard.totalStats.mobile_app)}
          helper="Customers with the mobile app installed"
          isLoading={dashboard.isTotalStatsFetching}
        />
      </div>

      <TrendsWidget
        contractorOptions={dashboard.contractorOptions}
        isContractorsLoading={dashboard.isContractorsLoading}
        thermostatTrendOption={dashboard.trends.thermostatTrendOption}
        customerTrendOption={dashboard.trends.customerTrendOption}
        systemHealthTrendOption={dashboard.trends.systemHealthTrendOption}
        contractorId={dashboard.trends.contractorId}
        installationTrendColumns={dashboard.trends.installationTrendColumns}
        customerTrendColumns={dashboard.trends.customerTrendColumns}
        systemHealthTrendColumns={dashboard.trends.systemHealthTrendColumns}
        onThermostatTrendOptionChange={dashboard.trends.setThermostatTrendOption}
        onCustomerTrendOptionChange={dashboard.trends.setCustomerTrendOption}
        onSystemHealthTrendOptionChange={dashboard.trends.setSystemHealthTrendOption}
        onContractorChange={dashboard.trends.setContractorId}
      />

      <ThermostatsWidget
        contractorOptions={dashboard.contractorOptions}
        isContractorsLoading={dashboard.isContractorsLoading}
        thermostatChartOption={dashboard.thermostats.thermostatChartOption}
        contractorId={dashboard.thermostats.contractorId}
        installsOverTimeData={dashboard.thermostats.installsOverTimeData}
        installedVsOrderedData={dashboard.thermostats.installedVsOrderedData}
        mobileAppVsCustomersData={dashboard.thermostats.mobileAppVsCustomersData}
        onThermostatChartOptionChange={dashboard.thermostats.setThermostatChartOption}
        onContractorChange={dashboard.thermostats.setContractorId}
      />

      <OrdersWidget
        contractorOptions={dashboard.contractorOptions}
        isContractorsLoading={dashboard.isContractorsLoading}
        orderChartOption={dashboard.orders.orderChartOption}
        contractorId={dashboard.orders.contractorId}
        orderStatuses={dashboard.orders.orderStatuses}
        orderStatusChartData={dashboard.orders.orderStatusChartData}
        orderStatusLegendItems={dashboard.orders.orderStatusLegendItems}
        orderedByTypeChartData={dashboard.orders.orderedByTypeChartData}
        onOrderChartOptionChange={dashboard.orders.setOrderChartOption}
        onContractorChange={dashboard.orders.setContractorId}
      />

      <AlertsWidget
        contractorOptions={dashboard.contractorOptions}
        isContractorsLoading={dashboard.isContractorsLoading}
        alertChartOption={dashboard.alerts.alertChartOption}
        contractorId={dashboard.alerts.contractorId}
        alertsOverTimeChartData={dashboard.alerts.alertsOverTimeChartData}
        alertStatusChartData={dashboard.alerts.alertStatusChartData}
        onAlertChartOptionChange={dashboard.alerts.setAlertChartOption}
        onContractorChange={dashboard.alerts.setContractorId}
      />

      <PerformanceTestsWidget
        contractorOptions={dashboard.contractorOptions}
        isContractorsLoading={dashboard.isContractorsLoading}
        perftestChartOption={dashboard.performanceTests.perftestChartOption}
        contractorId={dashboard.performanceTests.contractorId}
        performanceChartData={dashboard.performanceTests.performanceChartData}
        onPerftestChartOptionChange={dashboard.performanceTests.setPerftestChartOption}
        onContractorChange={dashboard.performanceTests.setContractorId}
      />
    </main>
  )
}

export default EnterpriseDashboard
